import { FeatureEnum } from './feature.model';
import { ParamsEnum } from './params.model';
import { CallbackOnCallNoteDTO } from './callback-on-callnote.model';
import dayjs from 'dayjs';
import { SERVER_TIME_ZONE } from '../constants/time-zone';

export enum ConfigurationTypeEnum {
	CALLBACK_ON_CALLNOTE,
	FEEDBACK,
	CALLNOTE_INFO,
	/** `?sipOrder&uid=<uid>`, see `CONFIGURATIONS`. */
	SIP_ORDER,
}

export type Configuration = {
	type: ConfigurationTypeEnum;
	params: Params;
	features: FeatureEnum[];
};

export interface Params {
	required: ParamsEnum[];
	optional: ParamsEnum[];
}

export const CONFIGURATIONS: Configuration[] = [
	/** Must be first: sipOrder links also carry `uid`, which the callnote entries match. */
	{
		type: ConfigurationTypeEnum.SIP_ORDER,
		features: [FeatureEnum.SIP_ORDER],
		params: {
			required: [ParamsEnum.SIP_ORDER],
			optional: [],
		},
	},
	{
		type: ConfigurationTypeEnum.FEEDBACK,
		features: [FeatureEnum.FEEDBACK, FeatureEnum.NOTE],
		params: {
			required: [ParamsEnum.UID, ParamsEnum.RATING],
			optional: [ParamsEnum.PRINT],
		},
	},
	{
		type: ConfigurationTypeEnum.FEEDBACK,
		features: [FeatureEnum.FEEDBACK, FeatureEnum.NOTE],
		params: {
			required: [ParamsEnum.UID, ParamsEnum.CORRECT],
			optional: [ParamsEnum.PRINT],
		},
	},
	{
		type: ConfigurationTypeEnum.CALLBACK_ON_CALLNOTE,
		features: [FeatureEnum.CALLBACK_ON_CALLNOTE, FeatureEnum.NOTE],
		params: {
			required: [ParamsEnum.UID, ParamsEnum.SUGGESTION],
			optional: [ParamsEnum.SHOW_PRICE_INFO, ParamsEnum.PRINT],
		},
	},
	{
		type: ConfigurationTypeEnum.CALLNOTE_INFO,
		features: [FeatureEnum.NOTE],
		params: {
			required: [ParamsEnum.UID, ParamsEnum.NOTE],
			optional: [ParamsEnum.PRINT], // no visible print button, but &print triggers auto-print via Note.printMode
		},
	},
	{
		type: ConfigurationTypeEnum.FEEDBACK,
		features: [FeatureEnum.FEEDBACK, FeatureEnum.NOTE],
		params: {
			required: [ParamsEnum.UID, ParamsEnum.PRINT],
			optional: [],
		},
	},
	{
		type: ConfigurationTypeEnum.CALLBACK_ON_CALLNOTE,
		features: [FeatureEnum.CALLBACK_ON_CALLNOTE, FeatureEnum.NOTE],
		params: {
			required: [ParamsEnum.UID],
			optional: [ParamsEnum.SUGGESTION, ParamsEnum.SHOW_PRICE_INFO, ParamsEnum.PRINT],
		},
	},
];

export interface CallbackOnCallNoteWorkflow {
	uid: string;
	suggestion: string | null;
	priceInfo: boolean | null;
}

export class CallbackOnCallNote implements CallbackOnCallNoteWorkflow {
	public preselectedSuggestion: number | undefined;
	uid: string;
	suggestion: string | null;
	priceInfo: boolean | null;
	localProcessingDate: Date | null = null;

	constructor(
		public readonly callbackOnCallNoteDTO: CallbackOnCallNoteDTO,
		workflowData: CallbackOnCallNoteWorkflow,
	) {
		this.priceInfo = !!workflowData.priceInfo;
		this.uid = workflowData.uid;
		this.suggestion = workflowData.suggestion;

		if (callbackOnCallNoteDTO.callNote.processingStart) {
			const serverDate = dayjs.tz(callbackOnCallNoteDTO.callNote.processingStart, SERVER_TIME_ZONE);
			const localDate = serverDate.local();
			this.localProcessingDate = localDate.toDate();
		}

		if (this.suggestion !== null) {
			this.preselectedSuggestion = +this.suggestion;
		}
	}
}
